import appConstants from '../../../../../../appConstants';
import { formatDate, formatESTDateTime, mergeUserConfig } from '@dataGrid/gridUtilities';
import {
  DateTimeFilter,
  MultiSelectFilter
} from '@dataGrid/components/columnFilters';

class GridConfig {
  constructor(configuration) {
    this.config = GridConfig.getConfiguration(configuration);
  }
  static getConfiguration({ userConfig }) {
    const defaultConfig = GridConfig.getDefaultConfiguration();
    return mergeUserConfig({
      defaultConfig,
      userConfig
    });
  }

  static getPlannersBreakdownString({data}) {
    const {planners} = data;
    if(!planners?.length) return '';
    return planners.join(', ');
  }

  static tooltipValueGetter(params) {
    return params.value;
  }

  static getDefaultConfiguration() {
    return {
      title: 'Usage Details',
      // Opt out of DataGrid’s sizeColumnsToFit for this wide grid (ag-grid v21); see config.skipSizeColumnsToFit in dataGrid/index.js.
      skipSizeColumnsToFit: true,
      columns: [
        {
          headerName: 'Start Date',
          field: 'startDate',
          headerTooltip: 'Start Date',
          minWidth: appConstants.columnWidth.W_90,
          valueFormatter: formatDate,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATE
          }
        },
        {
          headerName: 'End Date',
          field: 'endDate',
          headerTooltip: 'End Date',
          minWidth: appConstants.columnWidth.W_90,
          valueFormatter: formatDate,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATE
          }
        },
        {
          headerName: 'Division',
          field: 'division',
          headerTooltip: 'Division',
          minWidth: appConstants.columnWidth.W_120,
          tooltipValueGetter: GridConfig.tooltipValueGetter,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Region',
          field: 'region',
          headerTooltip: 'Region',
          minWidth: appConstants.columnWidth.W_120,
          tooltipValueGetter: GridConfig.tooltipValueGetter,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Terminal',
          field: 'terminalCode',
          headerTooltip: 'Terminal Code',
          minWidth: appConstants.columnWidth.W_120,
          tooltipValueGetter: GridConfig.tooltipValueGetter,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Routes',
          field: 'routesCount',
          headerTooltip: 'Routes Count',
          minWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Stops',
          field: 'stopsCount',
          headerTooltip: 'Stops Count',
          minWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Shipments',
          field: 'shipmentsCount',
          headerTooltip: 'Shipments Count',
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Dynamic Optimizer Runs',
          field: 'dynamicOptimizerRunsCount',
          headerTooltip: 'Dynamic Optimizer Runs Count',
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Sequence Optimizer Runs',
          field: 'sequenceOptimizerRunsCount',
          headerTooltip: 'Sequence Optimizer Runs Count',
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'City Routes',
          field: 'cityRoutesCount',
          headerTooltip: 'City Routes Count',
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Trap Routes',
          field: 'trapRoutesCount',
          headerTooltip: 'Trap Routes Count',
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Manually Created Routes',
          field: 'manuallyCreatedRoutesCount',
          headerTooltip: 'Manually Created Routes Count',
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Optimization Created Routes',
          field: 'optimizationCreatedRoutesCount',
          headerTooltip: 'Optimization Created Routes Count',
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Manually Adjusted Routes',
          field: 'manuallyAdjustedRoutesCount',
          headerTooltip: 'Manually Adjusted Routes Count',
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'System Created Routes',
          field: 'systemCreatedRoutesCount',
          headerTooltip: 'System Created Routes Count',
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Total Publishes',
          field: 'totalPublishesCount',
          headerTooltip: 'Total Publishes Count',
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Plan Creation',
          field: 'planCreationTime',
          headerTooltip: 'Plan Creation Time',
          minWidth: appConstants.columnWidth.W_140,
          valueFormatter: formatESTDateTime,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME
          }
        },
        {
          headerName: 'First Optimization',
          field: 'firstOptimizationTime',
          headerTooltip: 'First Optimization Time',
          minWidth: appConstants.columnWidth.W_160,
          valueFormatter: formatESTDateTime,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME
          }
        },
        {
          headerName: 'Planners',
          field: 'plannersCount',
          headerTooltip: 'Planners Count',
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter
        },
        {
          headerName: 'Planner Breakdown',
          field: 'planners',
          headerTooltip: 'Planner Breakdown',
          minWidth: appConstants.columnWidth.W_300,
          valueGetter: GridConfig.getPlannersBreakdownString,
          tooltipValueGetter: GridConfig.tooltipValueGetter,
          filterFramework: MultiSelectFilter,
          filterParams: {
            isValueList: true
          }
        }
      ]
    };
  }
}

export default GridConfig;
